<template>
  <div class="bb-reject-service-kpi">
    <div class="bb-reject-service-kpi-body">
      <div class="bb-reject-service-kpi-body__text">State the reason why project was rejected:</div>
      <div class="bb-reject-service-kpi-body__options">
        <checkbox v-for="option in rejectOptions"
                  :key="option.id"
                  :name="option.text"
                  :section="option"
                  :styleText="true"
                  class="bb-reject-service-kpi-body__checkbox"
                  @checkboxChange="changeCheckbox"
                  :checkboxText="option.text"/>
        <textarea class="bb-input bb-input_border bb-reject-service-kpi-body__textarea"
                  @input="inputOther($event)"
                  placeholder="Enter text..."
                  :class="{'bb-reject-service-kpi-body__textarea_disabled ': !checkedOther}"
                  :disabled="!checkedOther"/>
      </div>
    </div>
    <div class="bb-reject-service-kpi-footer">
      <button class="bb-button bb-button_border bb-button_border_gray"
              @click="closeForm"
      >
        CANCEL
      </button>
      <button class="bb-button"
              @click="saveForm"
              :disabled="notSelected"
      >
        SAVE
      </button>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Main/Inputs/checkbox'
import _ from 'lodash'
export default {
  name: 'RejectServiceKPI',
  props: ['project'],
  components: {
    Checkbox
  },
  computed: {
    notSelected () {
      return this.checkedOptions.length === 0
    }
  },
  data () {
    return {
      rejectOptions: [
        {
          id: 0,
          text: 'our fee is too high for the client'
        },
        {
          id: 1,
          text: 'client decided to proceed with a different service provider'
        },
        {
          id: 2,
          text: 'client does not reply for a long time'
        },
        {
          id: 3,
          text: 'other'
        }
      ],
      displayText: false,
      valueOther: '',
      checkedOther: false,
      checkedOptions: [],
      error: ''
    }
  },
  methods: {
    closeForm () {
      this.$emit('close')
    },
    changeCheckbox (data, name, section) {
      if (name === 'other') this.checkedOther = data
      const index = _.findIndex(this.checkedOptions, {id: section.id})
      if (data && index === -1) {
        this.checkedOptions.push(section)
      } else if (index !== -1) {
        this.checkedOptions.splice(index, 1)
      }
    },
    inputOther (e) {
      this.valueOther = e.target.value
    },
    saveForm () {
      if (this.notSelected) return
      if (this.checkedOther) {
        const index = _.findIndex(this.checkedOptions, {text: 'other'})
        this.checkedOptions.splice(index, 1, {id: 3, text: this.valueOther})
      }
      this.$emit('reject', this.checkedOptions)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";
.bb-reject-service-kpi {
  position: relative;
  width: 521px;
  height: auto;
  transition: 0.3s;

  &-body {
    padding: 11px 20px;

    &__text {
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 18px;
      text-align: start;
    }

    &__textarea {
      font-size: 14px;
      line-height: 17px;
      font-weight: normal;
      border: 1px solid $color-mercury;
      box-sizing: border-box;
      border-radius: 5px;
      padding: 10px 10px;
      width: 100%;
      min-height: 85px;
      transition: .3s;
      resize: none;

      &::placeholder {
        font-size: 13px;
        line-height: 16px;
        color: $color-silver;
      }

      &_disabled {
        background-color: rgba($color-wild-sand, 0.5);
      }
    }

    &__checkbox {
      font-size: 15px;
      line-height: 18px;
    }

    &__options {
      display: grid;
      grid-gap: 13px;
      margin: 16px 0 11px;
    }
  }

  &-footer {
    display: grid;
    grid-template-columns: 103px 103px;
    grid-gap: 12px;
    align-items: center;
    justify-content: end;
    padding: 18px;
    height: 100%;
    background: $color-alabaster;
    border-radius: 0 0 8px 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Finance/KPI/RejectServiceKPI/RejectServiceKPI.vue